import React from 'react';
import { Button, Flex } from '@companydotcom/potion';

import { ImageFeed } from '../components';
import { AcgRssFeedResponse } from '@companydotcom/types';

export interface TileAcgMediaNewsProps extends AcgRssFeedResponse {}

export const TileAcgMediaNews: React.FC<TileAcgMediaNewsProps> = props => {
  return (
    <Flex
      flexDirection="column"
      flexGrow={1}
      width="full"
      mt={1}
      alignItems="center"
      justifyContent="center"
    >
      <ImageFeed {...props} />
      <Button
        variant="tile"
        onClick={() => {
          window.open('https://middlemarketgrowth.org/category/news-trends/');
        }}
        width="fit-content"
        size="md"
        type="submit"
      >
        GO TO NEWS & TRENDS
      </Button>
    </Flex>
  );
};
